import definition from './developer.service';

/**
 * DeveloperApi settings
 * @type {{name: string, definition: DeveloperApi}}
 */
export default {
    name: 'DeveloperApi',
    definition
};



// WEBPACK FOOTER //
// ./app/services/api/developer/index.js